import * as React from 'react'
import { getAuthLifecycleHooks, registerAuthLifecycleHooks } from '@repo/auth-utils'
import { clearAidaPersistedSession } from '../stores/clear-persisted-session'

export function useClearAidaOnLogOut() {
  React.useEffect(() => {
    const previous = getAuthLifecycleHooks()
    registerAuthLifecycleHooks({
      ...previous,
      onLogOut: () => {
        previous.onLogOut?.()
        clearAidaPersistedSession()
      },
    })
    return () => {
      registerAuthLifecycleHooks(previous)
    }
  }, [])
}
